import { useState } from "react";
import { useNavigate } from "react-router-dom";
import special from "../styles/special.module.scss";
import { buildApiUrl } from "../utilities/Static";

function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [received, setReceived] = useState(false);

  const navigate = useNavigate();
  const contactVisualStyle = {
    backgroundImage: `linear-gradient(180deg, rgba(8, 12, 12, 0.12), rgba(8, 12, 12, 0.84)), url(${process.env.PUBLIC_URL}/images/contact.jpg)`,
  };

  const URL_Mail = buildApiUrl("/mail/contact");

  const handleContact = () => {
    fetch(URL_Mail, {
      method: "POST",
      body: JSON.stringify({
        name,
        email,
        subject,
        message,
      }),
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.message === "ok") {
          setReceived(true);
        }
        console.log(res);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };
  if (received) {
    return (
      <div className={special.contactShell}>
        <div className={special.contactPage}>
          <div className={special.contactBackdrop}></div>
          <div className={special.contactFrame}>
            <div className={special.contactVisual} style={contactVisualStyle}>
              <div className={special.contactVisualOverlay}></div>
              <div className={special.contactVisualCopy}>
                <p className={special.contactVisualEyebrow}>Material library</p>
                <h2>Tell us what you are building.</h2>
                <p>
                  Questions about sourcing, swatches, or account access all go
                  through the same channel.
                </p>
                <div className={special.contactLogoRow}>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/asiatanLogo.png`}
                    alt="Asiatan logo"
                    className={special.contactLogo}
                  />
                  <img
                    src={`${process.env.PUBLIC_URL}/images/tectuffLogoWhite.png`}
                    alt="Tectuff logo"
                    className={special.contactLogo}
                  />
                </div>
              </div>
            </div>

            <div className={special.contactForm}>
              <h1>Message sent</h1>
              <p className={special.contactIntro}>
                Thanks for reaching out. We will get back to you shortly.
              </p>

              <div className={special.contactActions}>
                <button
                  className={special.contactButton}
                  type="button"
                  onClick={() => navigate("/library")}
                >
                  Go back to library
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={special.contactShell}>
      <div className={special.contactPage}>
        <div className={special.contactBackdrop}></div>
        <div className={special.contactFrame}>
          <div className={special.contactVisual} style={contactVisualStyle}>
            <div className={special.contactVisualOverlay}></div>
            <div className={special.contactVisualCopy}>
              <p className={special.contactVisualEyebrow}>Material library</p>
              <h2>Bring your next project into focus.</h2>
              <p>
                Use this form for sourcing questions, platform support, or help
                building a better collection.
              </p>
              <div className={special.contactLogoRow}>
                <img
                  src={`${process.env.PUBLIC_URL}/images/asiatanLogo.png`}
                  alt="Asiatan logo"
                  className={special.contactLogo}
                />
                <img
                  src={`${process.env.PUBLIC_URL}/images/tectuffLogoWhite.png`}
                  alt="Tectuff logo"
                  className={special.contactLogo}
                />
              </div>
            </div>
          </div>

          <div className={special.contactForm}>
            <h1>Contact MATLIB</h1>
            <p className={special.contactIntro}>
              If you have questions about sourcing, swatches, or account access,
              please fill out the form below and we will get back to you
              shortly.
            </p>

            <div className={special.contactInputGroup}>
              <label htmlFor="contact-name">Name</label>
              <input
                id="contact-name"
                type="text"
                onChange={(e) => setName(e.target.value)}
                value={name}
                placeholder="Your name"
              />
            </div>

            <div className={special.contactInputGroup}>
              <label htmlFor="contact-email">Email</label>
              <input
                id="contact-email"
                type="email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                placeholder="you@company.com"
              />
            </div>

            <div className={special.contactInputGroup}>
              <label htmlFor="contact-subject">Subject</label>
              <input
                id="contact-subject"
                type="text"
                onChange={(e) => setSubject(e.target.value)}
                value={subject}
                placeholder="What can we help with?"
              />
            </div>

            <div className={special.contactInputGroup}>
              <label htmlFor="contact-message">Message</label>
              <textarea
                id="contact-message"
                onChange={(e) => setMessage(e.target.value)}
                value={message}
                placeholder="Tell us what you need"
              />
            </div>

            <div className={special.contactActions}>
              <button
                className={special.contactButton}
                type="button"
                onClick={handleContact}
              >
                Send Email
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
